import { render, staticRenderFns } from "./PlatformAnalyticsChartGrid.vue?vue&type=template&id=4a7b666e"
import script from "./PlatformAnalyticsChartGrid.vue?vue&type=script&lang=js"
export * from "./PlatformAnalyticsChartGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports